module.exports = __webpack_public_path__ + "static/media/Spumante.da5acd79.png";